var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyIcon06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9635 0.581543C9.23348 0.581543 7.83106 1.98399 7.83106 3.71397C7.83106 5.44396 9.23348 6.84639 10.9635 6.84639C12.6936 6.84639 14.0959 5.44396 14.0959 3.71397C14.0959 1.98399 12.6936 0.581543 10.9635 0.581543ZM4.83889 6.67548C8.09956 6.67548 10.7428 9.31877 10.7428 12.5794V17.4184H7.80621V12.5794C7.80621 12.2321 7.74658 11.8989 7.63696 11.5892L3.32344 15.9027L1.24692 13.8261L5.40672 9.66639C5.22292 9.63078 5.03308 9.61212 4.83889 9.61212H0V6.67548H4.83889ZM17.1612 6.67548C13.9005 6.67548 11.2571 9.31877 11.2571 12.5794V17.4184H14.1938V12.5794C14.1938 12.3075 14.2304 12.044 14.2989 11.7938L18.8112 16.306L20.8878 14.2294L16.3755 9.71723C16.6257 9.64871 16.8892 9.61212 17.1612 9.61212H22V6.67548H17.1612Z",
    fill: "#0050FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon06);
export default __webpack_public_path__ + "static/media/company-icon-06.879bc3f95d02eef3f3872566ee0a5a7c.svg";
export { ForwardRef as ReactComponent };